import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import TitleBar from "../Layout/titleBar";
import { Row, Col } from "react-flexbox-grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import "./styles.css";
import Item from "./item";

const styles = () => ({
  root: {
    zIndex: 1200,
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "-5px 4px 10px #8E8E8E29",
    borderRadius: "21px",
    opacity: 1,
    padding: "0px !important",
    minWidth: "300px",
  },
  rootDialog: {
    zIndex: 1250,
  },
});

const Contenido = (props) => {
  const dragItem = useRef();
  const dragOverItem = useRef();
  const [itemsContenidos, setItemsContenidos] = useState([]);

  React.useEffect(() => {
    setItemsContenidos(
      props.contenidos.map((x) => ({
        idContenido: x.idContenido,
        pathImagen: x.pathImagen,
        textoCorto: x.textoCorto,
        fechaActivacion: x.fechaActivacion,
        fechaDesactivacion: x.fechaDesactivacion,
        activo: x.activo,
        tipoContenidoSelectedImg: x.tipoContenidoSelectedImg,
        nombreUsuarioRegistro: x.nombreUsuarioRegistro,
        textoLargo: x.textoLargo,
        idTipoContenido: x.idTipoContenido,
      }))
    );
  }, [props.contenidos]);

  const dragStart = (position) => {
    dragItem.current = position;
    //console.log(e.target.innerHTML);
  };

  const dragEnter = (position) => {
    dragOverItem.current = position;
    //console.log(e.target.innerHTML);
  };

  const drop = () => {
    const copyListItems = [...itemsContenidos];
    const dragItemContent = copyListItems[dragItem.current];
    const dragOverItemContent = copyListItems[dragOverItem.current];
    copyListItems.splice(dragItem.current, 1); //se borra
    copyListItems.splice(dragItem.current, 0, dragOverItemContent);
    copyListItems.splice(dragOverItem.current, 1); //se borra
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;

    props.handleOnSwap(
      copyListItems.map((x) => x.idContenido.toString()),
      props.contenidos[0].idTipoContenido
    );

    setItemsContenidos(copyListItems);
  };

  const { classes } = props;

  const renderSearchBar = () => {
    return (
      <Row className="searchBar">
        <Col>
          <TextField
            className="filterInput"
            select
            value={props.tipoContenidoSelected}
            name="idTipoContenido"
            onChange={props.handleOnChangeTipoContenido}
            placeholder="Tipo Contenido"
          >
            {/*<MenuItem key={0} value={0}>
                            {'Todos los contenidos'}
                        </MenuItem>*/}

            {props.tiposContenido &&
              props.tiposContenido.map((e) => (
                <MenuItem key={e.idTipoContenido} value={e.idTipoContenido}>
                  {e.nombre}
                </MenuItem>
              ))}
          </TextField>
        </Col>
      </Row>
    );
  };

  return (
    <>
      {/* menú superior */}
      <TitleBar
        title={"Contenidos"}
        searchBar={renderSearchBar()}
        handleOnSearch={props.handleOnClickBuscar}
        searchPlaceholder="Contenido"
        showSearch={true}
        newButtonLink="/Contenido/Nuevo"
      />

      <Row style={{ margin: "0px" }} className="draggable">
        {itemsContenidos &&
          itemsContenidos.map((item, index) => (
            <Col
              md={6}
              lg={4}
              onDragStart={() => dragStart(index)}
              onDragEnter={() => dragEnter(index)}
              onDragEnd={drop}
              key={index}
              className="draggable"
              draggable
            >
              <Item item={item} {...props}></Item>
            </Col>
          ))}
      </Row>
      {(props.contenidos === undefined || props.contenidos.length === 0) && (
        <div className="noContenidos">
          No se encontraron contenidos activos para el tipo de contenido seleccionado
        </div>
      )}
      {/* VER */}
      {/*
            <Dialog
                classes={{root: classes.rootDialog, paperScrollPaper: classes.root}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='sm'
                open={this.props.openModalVer}
                fullWidth={true}
            >
                <DialogContent classes={{root: classes.root}}>

                    <Row style={{margin: '0px'}}>

                        <Col xs={12} md={12} lg={12}  style={{padding: '0px'}}>
                            <div className='containerModalVer'>
                                <div className='titleModal'>{this.props.itemSelectedVer ? this.props.itemSelectedVer.textoCorto : ''}</div>
                                
                                {this.props.itemTipoContenidoSelected && this.props.itemTipoContenidoSelected.idTipoContenido !== 3 ?
                                    <div className='imgModal'>
                                        <img src={this.props.itemSelectedVer ? this.props.itemSelectedVer.pathImagen : ''} alt=""></img>
                                    </div>
                                :
                                    <div className='textoLargo'>
                                        {this.props.itemSelectedVer ? this.props.itemSelectedVer.textoLargo : ''}
                                    </div>
                                }

                                <div className='containerButtonsModal'>
                                    <Button className='btnCerrarModal' onClick={this.props.handleOnClickCerrarModal}>
                                        CERRAR
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    
                    </Row>

                </DialogContent>
            </Dialog>
            */}
      {/* VER */}
      <Dialog
        classes={{ root: classes.rootDialog, paperScrollPaper: classes.root }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        open={props.openModalVer}
        fullWidth={true}
      >
        <DialogContent classes={{ root: classes.root }}>
          <Row style={{ margin: "0px" }}>
            <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
              <div className="containerModalVer">
                <div className="titleModal">
                  {props.itemSelectedVer ? props.itemSelectedVer.textoCorto : ""}
                </div>
                {props.itemSelectedVer && props.itemSelectedVer.idTipoContenido !== 3 ? (
                  <div className="imgModal">
                    <img
                      src={props.itemSelectedVer ? props.itemSelectedVer.pathImagen : ""}
                      alt=""
                    ></img>
                  </div>
                ) : (
                  <div className="textoLargo">
                    {props.itemSelectedVer ? props.itemSelectedVer.textoLargo : ""}
                  </div>
                )}

                <div className="containerButtonsModal">
                  <Button className="btnCerrarModal" onClick={props.handleOnClickCerrarModal}>
                    CERRAR
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </DialogContent>
      </Dialog>

      {/* CONFIRMAR BORRAR */}
      <Dialog
        classes={{ root: classes.rootDialog, paperScrollPaper: classes.root }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        open={props.openModalBorrar}
        fullWidth={true}
      >
        <DialogContent classes={{ root: classes.root }}>
          <Row style={{ margin: "0px" }}>
            <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
              <div className="containerModalVer">
                <div className="titleModal">Está seguro que desea borrar el contenido?</div>

                <div className="containerButtonsModal">
                  <Button className="btnCerrarModal" onClick={props.handleOnClickCerrarModal}>
                    CERRAR
                  </Button>
                  <Button
                    className="btnBorrarModal"
                    onClick={() => props.handleOnClickBorrar(undefined, true)}
                  >
                    BORRAR
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </DialogContent>
      </Dialog>
    </>
  );
};

Contenido.propTypes = {
  handleOnSearch: PropTypes.func.isRequired,
  tipoContenidoSelected: PropTypes.number.isRequired,
  tiposContenido: PropTypes.array.isRequired,
  itemTipoContenidoSelected: PropTypes.object,
  contenidos: PropTypes.array.isRequired,
  openModalVer: PropTypes.bool,
  itemSelectedVer: PropTypes.object,
  itemSelectedEditar: PropTypes.object,
  openModalBorrar: PropTypes.bool,
  handleOnChangeTipoContenido: PropTypes.func.isRequired,
  handleOnClickBuscar: PropTypes.func.isRequired,
  handleOnClickVer: PropTypes.func.isRequired,
  handleOnClickEditar: PropTypes.func.isRequired,
  handleOnClickBorrar: PropTypes.func.isRequired,
  handleOnClickCerrarModal: PropTypes.func.isRequired,
  handleOnSwap: PropTypes.func.isRequired,
};

Contenido.defaultProps = {
  tiposContenido: [],
  contenidos: [],
  canSwap: true,
  openModalVer: false,
  itemSelectedVer: undefined,
  itemSelectedEditar: [],
  handleOnChangeTipoContenido: (f) => f,
  handleOnClickBuscar: (f) => f,
  handleOnClickVer: (f) => f,
  handleOnClickEditar: (f) => f,
  handleOnClickBorrar: (f) => f,
  handleOnClickCerrarModal: (f) => f,
  handleOnSwap: (f) => f,
};

export default withStyles(styles)(Contenido);
